/**
 * New alias for the backend experiments
 *
 * show|hide will apply to all visibility experiments
 */

import type { BackendExperiment } from './types'

const experiment_aliases: Record<string, BackendExperiment> | null = {
  firework_show: {
    experiment_id: 'firework_visibility',
    base_experiment_type: 'firework_visibility',
    variant_value: 'show',
    name: `URL Override: firework_visibility`,
  },
  firework_hide: {
    experiment_id: 'firework_visibility',
    base_experiment_type: 'firework_visibility',
    variant_value: 'hide',
    name: `URL Override: firework_visibility`,
  },
  widget_show: {
    experiment_id: 'embed_visibility',
    base_experiment_type: 'embed_visibility',
    variant_value: 'show',
    name: `URL Override: embed_visibility`,
  },
  widget_hide: {
    experiment_id: 'embed_visibility',
    base_experiment_type: 'embed_visibility',
    variant_value: 'hide',
    name: `URL Override: embed_visibility`,
  },
  ava_show: {
    experiment_id: 'ava_visibility',
    base_experiment_type: 'ava_visibility',
    variant_value: 'show',
    name: `URL Override: ava_visibility`,
  },
  ava_hide: {
    experiment_id: 'ava_visibility',
    base_experiment_type: 'ava_visibility',
    variant_value: 'hide',
    name: `URL Override: ava_visibility`,
  },
}

/**
 *
 * @param alias
 * @returns
 */
export const getExperimentByAlias = (
  alias: string,
): BackendExperiment | null => {
  if (!alias) {
    return null
  }

  const experiment = experiment_aliases[alias]

  return experiment || null
}
